<template>
  <div class="notification is-info is-light" v-if="isActive">
    <button class="delete" @click="clickDeleteButton()"></button>
    {{ imsrVersion.date }}
    <p>
      {{ imsrVersion.updateDate }}&nbsp;
      {{ $t("update.message1") }}
      <a :href="url">{{ $t("update.message2") }}</a>
      {{ $t("update.message3") }}
    </p>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import imsrVersion from "@/imsrVersion.js";
import Cookies from "js-cookie";
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const isActive = ref(false);
    const updateCheckDateCookies = ref("");
    const { t } = useI18n();
    const url = "/help/" + t("update.lang") + "/version.html";

    const clickDeleteButton = () => {
      const now = new Date();
      isActive.value = false;
      Cookies.set("updateCheckDate", now, { expires: 90 });
    };

    onMounted(() => {
      const now = new Date();
      const updateDate = new Date(imsrVersion.updateDate);
      const expireDate = new Date(updateDate);
      expireDate.setDate(updateDate.getDate() + imsrVersion.expireDays);
      updateCheckDateCookies.value = Cookies.get("updateCheckDate");

      if (
        !updateCheckDateCookies.value &&
        now <= expireDate &&
        now >= updateDate
      ) {
        isActive.value = true;
      } else {
        const updateCheckDate = new Date(updateCheckDateCookies.value);
        if (updateCheckDate < updateDate && updateCheckDate < expireDate) {
          isActive.value = true;
        }
      }
    });

    return {
      isActive,
      imsrVersion,
      clickDeleteButton,
      url,
    };
  },
};
</script>
